import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-price1-icon',
  templateUrl: './shopping-price1.component.html'
})
export class ShoppingPrice1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
